/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entryticketsempty2Inputs */

const en_entryticketsempty2 = /** @type {(inputs: Entryticketsempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add the first ticket type, for example Regular or Students.`)
};

const de_entryticketsempty2 = /** @type {(inputs: Entryticketsempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leg die erste Ticketart an, zum Beispiel Normal oder Studierende.`)
};

/**
* | output |
* | --- |
* | "Add the first ticket type, for example Regular or Students." |
*
* @param {Entryticketsempty2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entryticketsempty2 = /** @type {((inputs?: Entryticketsempty2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entryticketsempty2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entryticketsempty2(inputs)
	return de_entryticketsempty2(inputs)
});
export { entryticketsempty2 as "entryTicketsEmpty" }